import { defineComponent, type ReactiveComponent } from "vue-utils"

const NotFound: ReactiveComponent = () => {
	return () => (
		<div>
			<h1>Not Found</h1>
			<div>The page you requested could not be found</div>
		</div>
	)
}

export default defineComponent(NotFound)
